var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3814",
    "data-name": "Group 3814",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.992,
    height: 23,
    viewBox: "0 0 22.992 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_923",
    "data-name": "Rectangle 923",
    width: 22.992,
    height: 23,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2504",
    "data-name": "Group 2504",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2621",
    "data-name": "Path 2621",
    d: "M22.993,15.169a.936.936,0,0,1-.861.643.888.888,0,0,1-.949-.933q0-4.632,0-9.265a1.93,1.93,0,0,0-.67-1.594A1.963,1.963,0,0,0,19.3,3.61c-.284-.014-.568,0-.852-.006-.162-.005-.208.063-.2.213.008.239.006.479,0,.718a.913.913,0,0,1-1.823,0c0-.247-.006-.494,0-.74,0-.135-.049-.185-.184-.185q-1.84,0-3.679,0c-.15,0-.2.059-.192.2.007.239,0,.479,0,.718a.913.913,0,0,1-1.824,0q-.006-.37,0-.74c0-.123-.046-.175-.172-.174q-1.828,0-3.657,0c-.138,0-.184.056-.182.188.005.247,0,.494,0,.74a.913.913,0,0,1-1.823,0c0-.247,0-.494,0-.74,0-.1-.007-.184-.136-.184a5.709,5.709,0,0,0-1.384.07A1.8,1.8,0,0,0,1.828,5.572q0,2.905,0,5.81,0,3.881,0,7.762a2.184,2.184,0,0,0,.192,1A1.829,1.829,0,0,0,3.8,21.165q3.926,0,7.852,0,3.769,0,7.538,0a1.909,1.909,0,0,0,1.6-.7,2.066,2.066,0,0,0,.386-1.1.922.922,0,0,1,.728-.879.933.933,0,0,1,1.045.554l.04.08v.808c-.011.043-.025.086-.034.129A3.66,3.66,0,0,1,19.366,23c-5.242-.022-10.485-.008-15.728-.007a4.216,4.216,0,0,1-.692-.049A3.6,3.6,0,0,1,0,19.494Q0,12.382,0,5.269a2.436,2.436,0,0,1,.011-.314A3.606,3.606,0,0,1,3.649,1.779c.261.01.524-.011.785.005.21.013.306-.047.282-.272-.017-.155.007-.315,0-.471A.966.966,0,0,1,5.356,0h.539a.967.967,0,0,1,.646,1.04c-.013.171.009.344,0,.515s.065.228.235.227q1.771-.008,3.543,0c.171,0,.25-.043.235-.227s.008-.345,0-.515A.967.967,0,0,1,11.19,0h.539a.967.967,0,0,1,.646,1.04c-.013.171.009.344,0,.515s.065.228.235.227q1.794-.008,3.588,0c.171,0,.25-.043.235-.227s.008-.344,0-.515A.967.967,0,0,1,17.069,0h.538a.967.967,0,0,1,.646,1.038c-.013.178.005.359,0,.537-.008.157.055.21.209.206.343-.008.687,0,1.03,0a3.46,3.46,0,0,1,2.322.91,3.708,3.708,0,0,1,1.183,2.156Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M67.834,122.687a.913.913,0,1,1,.911-.9.89.89,0,0,1-.911.9",
    transform: "translate(-62.207 -112.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M124.186,121.784a.913.913,0,1,1-.891-.923.89.89,0,0,1,.891.923",
    transform: "translate(-113.744 -112.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M178.713,120.862a.913.913,0,1,1-.912.9.89.89,0,0,1,.912-.9",
    transform: "translate(-165.28 -112.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M234.134,122.687a.913.913,0,1,1,.933-.881.889.889,0,0,1-.933.881",
    transform: "translate(-216.816 -112.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M67.83,178.128a.913.913,0,1,1,.915-.9.89.89,0,0,1-.915.9",
    transform: "translate(-62.207 -163.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M123.262,178.128a.913.913,0,1,1,.923-.891.89.89,0,0,1-.923.891",
    transform: "translate(-113.743 -163.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M68.746,232.654a.913.913,0,1,1-.9-.911.89.89,0,0,1,.9.911",
    transform: "translate(-62.208 -215.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M124.186,232.654a.913.913,0,1,1-.9-.911.89.89,0,0,1,.9.911",
    transform: "translate(-113.744 -215.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2823",
    "data-name": "Path 2823",
    d: "M178.713,120.862a.913.913,0,1,1-.912.9.89.89,0,0,1,.912-.9",
    transform: "translate(-165.28 -108.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2824",
    "data-name": "Path 2824",
    d: "M234.134,122.687a.913.913,0,1,1,.933-.881.889.889,0,0,1-.933.881",
    transform: "translate(-216.816 -108.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2825",
    "data-name": "Path 2825",
    d: "M178.713,120.862a.913.913,0,1,1-.912.9.89.89,0,0,1,.912-.9",
    transform: "translate(-165.28 -104.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2826",
    "data-name": "Path 2826",
    d: "M234.134,122.687a.913.913,0,1,1,.933-.881.889.889,0,0,1-.933.881",
    transform: "translate(-216.816 -104.656)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.1008ecd01c35021dbfc4c3a75357c902.svg";
export { ForwardRef as ReactComponent };